<template>
    <div class="container">
        <van-nav-bar leftText leftArrow @click-left="backGo" title="选择银行卡" class="headerbar">
            <van-button slot="right" class="btn btn-text" @click="onAddClick">
                <div class="ico-blackadd bg-contain"></div>
            </van-button>
        </van-nav-bar>
        <div class="topbar-container">
            <zbView :isEmpty="!bankList.length" @reLoad="loadList(true)">
                <div class="bankList-list">
                    <div class="line"></div>
                    <div
                        v-for="(item,i) in bankList"
                        :key="i"
                        @click="onSelectClick(item)"
                        class="bankList-list-item border-bottom"
                    >
                        <div class="item bh bstart">
                            <div
                                class="bg-contain ico"
                                :style="{backgroundImage: `url('${item.bankIcon}')`}"
                            ></div>
                            <div class="b1 c_black fz_34">{{item.bankName}}&emsp;({{item.bankNo}})</div>
                            <div v-if="selectId==item.bankCardNumber" class="ico-select bg-contain"></div>
                        </div>
                    </div>
                </div>
                <div class="line"></div>
            </zbView>
        </div>
    </div>
</template>

<script>
import { user } from "@/mixin/user";
import { routeCache } from "@/mixin/cache";
import { mixinBank } from "@/mixin/bank";
import zbView from "@/components/data/View";
export default {
    mixins: [user, routeCache, mixinBank],
    name: "UserBankSelect",
    components: { zbView },
    data() {
        return {
            selectId: ""
        };
    },
    computed: {
        newBankCardNumber() {
            return this.$store.getters["money/newBankCardNumber"];
        }
    },
    watch: {
        // 新增银行卡后自动选择新增银行卡
        newBankCardNumber: {
            handler(v) {
                if (v) {
                    this.selectId = v;
                    this.$store.state.money.newBankCardNumber = "";
                }
            },
            immediate: true
        }
    },
    methods: {
        userLoginend() {
            this.selectId = this.getCache().bankCardNumber;
            this.loadList();
        },
        onSelectClick(item) {
            const me = this;
            // 选择地址
            me.$store.state.money.selectBank = item;
            me.backGo();
        }
    }
};
</script>

<style scoped lang="scss">
@include ico-list("~@/assets/imges/ico/", "select");
.container {
    background-color: #f1f2f3;
}
.btn-text {
    padding-top: 26px;
}
.ico-blackadd {
    width: 36px;
    height: 36px;
}
.bankList-list-item {
    background-color: #fff;
    padding: 50px 30px;
    .ico {
        width: 42px;
        height: 42px;
        margin-right: 12px;
    }
    .ico-select {
        width: 33px;
        height: 33px;
    }
}
</style>

